import bus from "@/bus";
import storePublisherPlugin from "@/store/plugins";
import mocksStore from "@/__mocks__/store-mock.js";

jest.mock("@/bus", () => ({
  $emit: jest.fn()
}));

describe("storePublisherPlugin", () => {
  let mockStore;

  beforeEach(() => {
    mockStore = mocksStore;
    storePublisherPlugin(mockStore);
  });

  it("should subscribe to store mutations", () => {
    expect(mockStore.subscribe).toHaveBeenCalled();
  });

  it("should emit 'mutation' event on bus when a mutation occurs", () => {
    const mockState = mocksStore.state;
    const mockMutation = "exampleMutation";

    mockStore.subscribe.mock.calls[0][0](mockMutation, mockState);

    expect(bus.$emit).toHaveBeenCalledWith("mutation", {
      mutation: mockMutation,
      state: mockState
    });
  });
});
